export default "__VITE_ASSET__BxEIa5ZE__"